/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Learn_SkippedInputs */

const zh_learn_skipped = /** @type {(inputs: Learn_SkippedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`跳过`)
};

const en_learn_skipped = /** @type {(inputs: Learn_SkippedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skipped`)
};

const es_learn_skipped = /** @type {(inputs: Learn_SkippedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Omitido`)
};

/**
* | output |
* | --- |
* | "Skipped" |
*
* @param {Learn_SkippedInputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
export const learn_skipped = /** @type {((inputs?: Learn_SkippedInputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Learn_SkippedInputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_learn_skipped(inputs)
	if (locale === "en") return en_learn_skipped(inputs)
	return es_learn_skipped(inputs)
});